import { useState } from 'react';

import { ClickableOptionsCard, TransferAccountsModalGroup } from 'core/Components';
import { Container, Stack, ThemeIcon } from 'ui';
import { IconLink, IconSecurityShield } from 'ui/Icons';

import { ProfileSettingsTemplate } from '../Profile/components/ProfileSettingsTemplate';
import { ManageMyCausesGroup } from './components/ManageMyCauses/ManageMyCausesGroup';
import { PrivacyModal } from './components/PrivacyModal';

const SettingsContent = () => {
  const [openModal, setOpenModal] = useState<
    'cause' | 'donation' | 'accounts' | 'privacy' | undefined
  >();
  return (
    <>
      <ProfileSettingsTemplate title="Settings">
        <Stack>
          <ClickableOptionsCard>
            <ManageMyCausesGroup />

            <TransferAccountsModalGroup
              openButton={(props) => (
                <ClickableOptionsCard.Row
                  onClick={() => props.openModalById('LinkedAccounts')}
                  leftSection={
                    <ThemeIcon variant="transparent" c="gray.2">
                      <IconLink />
                    </ThemeIcon>
                  }
                  title="Linked Accounts"
                />
              )}
            />
            <ClickableOptionsCard.Row
              leftSection={
                <ThemeIcon variant="transparent" c="gray.2">
                  <IconSecurityShield />
                </ThemeIcon>
              }
              title="Privacy Settings"
              onClick={() => setOpenModal('privacy')}
            />
          </ClickableOptionsCard>
        </Stack>
      </ProfileSettingsTemplate>
      <PrivacyModal opened={openModal === 'privacy'} onClose={() => setOpenModal(undefined)} />
    </>
  );
};

const Settings = () => {
  return (
    <Container size="xl">
      <SettingsContent />
    </Container>
  );
};

export { Settings };
